import Api from '../api'
import Fuels from '../models/fuels'

export default {
    getRegions(position, fuel, range, filters, callback) {
        const $scope = this;

        Api.getRegions(position, fuel, range, filters, function (err, res) {
            callback(res);
        });
    },
    get(country, region, fuel, callback) {
        Api.getRegion(country, region, fuel, function (err, res) {
            callback(res);
        });
    },
    getMarkers(position, fuel, range, filters, callback) {
        this.getRegions(position, fuel, range, filters, function (Regions) {
            var _markers = [];

            Regions.forEach(function (_region, index) {
                _markers.push({
                    type: 'region',
                    position: {
                        lat: Number.parseFloat(_region.position.lat),
                        lng: Number.parseFloat(_region.position.lng)
                    },
                    value: _region.value,
                    stations: _region.stations,
                    price: _region.avgprice,
                    style: {
                        "background-image": "url('" + require('../assets/pins/cluster.png') + "')"
                    },
                    zoom: _region.zoom,
                    next_hop: (parseInt(_region.nprovince) > 0) ? 'region' : 'province'
                })
            });

            callback(_markers);
        })
    }
}